import * as React from "react";
import type { SVGProps } from "react";

const SvgCollapseCaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={10}
    viewBox="0 0 15 10"
    {...props}
  >
    <path
      fill="#142745"
      fillRule="evenodd"
      d="M.44 9.006a1.497 1.497 0 0 0 2.121 0l4.77-4.767L12.1 9.006a1.496 1.496 0 0 0 2.12 0 1.497 1.497 0 0 0 0-2.121L7.327.001.44 6.885a1.497 1.497 0 0 0 0 2.121"
    />
  </svg>
);
export default SvgCollapseCaretDown;
